import Vue from 'vue';
import Multiselect from 'vue-multiselect'
import VueMask from 'v-mask'
import VueTippy, { TippyComponent } from "vue-tippy";
import { Money } from 'v-money';
import VueQuillEditor from 'vue-quill-editor'

//Estou importando desta forma devido ao sourcemap que fica dando erro
import StarRating from '../../node_modules/vue-star-rating/src/index.js';

// register globally
Vue.component("Multiselect", Multiselect);
Vue.component("VMoney", Money);
Vue.use(VueQuillEditor);

Vue.use(VueMask);
Vue.use(VueTippy);
Vue.component("Tippy", TippyComponent);

Vue.component("StarRating", StarRating);

//Components passport
Vue.component("PassportClients", require("./components/passport/Clients.vue").default);

Vue.component("PassportAuthorizedClients", require("./components/passport/AuthorizedClients.vue").default);

Vue.component("PassportPersonalAccessTokens", require("./components/passport/PersonalAccessTokens.vue").default);

Vue.component("ButtonToggleText", function (resolve) {
	require(["./components/Common/ButtonToggleText.vue"], resolve);
});

Vue.component("GroupedErrors", function (resolve) {
	require(["./components/Common/GroupedErrors.vue"], resolve);
});

Vue.component("NotesVue", function (resolve) {
	require(["./components/Common/Notes.vue"], resolve);
});

Vue.component("Modal", function (resolve) {
	require(["./components/Common/Modal"], resolve);
});

Vue.component("ModalContactShop", function (resolve) {
	require(["./components/ModalContactShop.vue"], resolve);
});

Vue.component("ContactModal", function (resolve) {
	require(["./components/Common/ContactModal.vue"], resolve);
});

Vue.component("MenuNotification", function (resolve) {
	require(["./components/Common/Notification"], resolve);
});

Vue.component("TableVue", function (resolve) {
	require(["./components/Common/Table/Table"], resolve);
});

Vue.component("Fotorama", function (resolve) {
	require(["./components/fotorama/Fotorama"], resolve);
});

Vue.component("Galery", function (resolve) {
	require(["./components/fotorama/Galery"], resolve);
});

Vue.component("BackToTop", function (resolve) {
	require(["./components/Common/BackToTop"], resolve);
});

Vue.component("ReportFiltersBtn", function (resolve) {
	require(["./components/Common/ReportFiltersBtn"], resolve);
});

Vue.component("VueCounterUp", function (resolve) {
	require(["./components/Common/CounterUp.vue"], resolve);
});

Vue.component("UserDetails", function (resolve) {
	require(["./components/Common/UserDetails.vue"], resolve);
});

Vue.component("UserDetailsJustName", function (resolve) {
	require(["./components/Common/UserDetailsJustName.vue"], resolve);
});

Vue.component("MessagePopup", function (resolve) {
	require(["./components/MessagePopup.vue"], resolve);
});

Vue.component("UploadFileWithDrop", function (resolve) {
	require(["./components/UploadFileWithDrop.vue"], resolve);
});